export enum ErrorCode {
  UNAUTHORIZED = 'UNAUTHORIZED',
  PERMISSION_DENIED = 'PERMISSION_DENIED',
  VALIDATION_ERROR = 'VALIDATION_ERROR',
  UNEXPECTED_ERROR = 'UNEXPECTED_ERROR',
  UNEXPECTED_METHOD = 'UNEXPECTED_METHOD',
  NOT_FOUND = 'NOT_FOUND',
  RATE_LIMIT_EXCEEDED = 'RATE_LIMIT_EXCEEDED',
  OUT_OF_CREDITS = 'OUT_OF_CREDITS',
  ABORTED = 'ABORTED',
  ENCRYPTED = 'ENCRYPTED',
}

export class CustomError extends Error {
  code: ErrorCode;
  validation: Array<any> | undefined;

  constructor(msg: string, code: ErrorCode) {
    super(msg);
    this.code = code;
  }
}

export function getErrorForClient(err: any): {
  message: string;
  code: ErrorCode;
  validation?: any[];
} {
  if (err instanceof CustomError) {
    return {
      message: err.message,
      code: err.code,
      validation: err.validation,
    };
  }

  return {
    message: 'An unexpected error occurred',
    code: ErrorCode.UNEXPECTED_ERROR,
  };
}
